// import './wdyr'
import React from 'react'
import ReactDOM from 'react-dom'
import '@fontsource/roboto/300'
import '@fontsource/roboto/400'
import '@fontsource/roboto/500'
import '@fontsource/roboto/700'
import '@fontsource/cambay/400'
import '@fontsource/cambay/700'
import 'material-icons/iconfont/outlined.css'
import 'material-icons/iconfont/round.css'
import '@material-symbols/font-300/outlined.css'
import './shared/assets/styles/global.css'
import './new/app/style/global.scss'
import App from './App'

// for disable iOS text field zoom
;(function () {
  if (!/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) return

  const el = document.querySelector('meta[name=viewport]')

  if (el !== null) {
    let content = el.getAttribute('content')
    let re = /maximum\-scale=[0-9\.]+/g

    if (re.test(content)) {
      content = content.replace(re, 'maximum-scale=1.0')
    } else {
      content = [content, 'maximum-scale=1.0'].join(', ')
    }

    el.setAttribute('content', content)
  }
})()

ReactDOM.render(<App />, document.getElementById('root'))

const errorsToWarn = ['Warning:']
const oldConsError = console.error

console.error = function (...args) {
  let toWarn = typeof args[0] === 'string' && errorsToWarn.some(s => args[0].startsWith(s))
  toWarn ? console.warn(...args) : oldConsError(...args)
}
